import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getProduct = async (id) => {
    const { data, error } = await supabase
        .from('products')
        .select(`
            *,
            brand:product_brand(*),
            images:product_images(*) 
        `)
        .eq('id', id)
        .single()

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetProductById(id) {
    return useQuery({
        queryKey: ['useGetProductById', id],
        queryFn: () => getProduct(id),
        staleTime: 1000 * 60, //1 minute
        enabled: !!id
    })
}
